import * as React from 'react';
import styled from 'styled-components';

import { color } from 'styles/utils';

import Layout from 'components/Layout';
import SEO from 'components/SEO';

import ReviewsHero from 'pageComponents/Reviews/ReviewsHero';

import DescriptionFeatureSection from 'pageComponents/Pulse/DescriptionFeatureSection';
import SleuthDifferenceFeatureSection from 'pageComponents/Pulse/SleuthDifferenceFeatureSection';
import DataSourcesFeatureSection from 'pageComponents/Pulse/DataSourcesFeatureSection';
import PulseFeatureSection from 'pageComponents/Pulse/PulseFeatureSection';

const StyledLayout = styled(Layout)`
  background-color: ${color('darkestTeal')};
  color: ${color('white')};
  position: relative;
`;

export default function DoraPage(props) {
  return (
    <StyledLayout {...props}>
      <ReviewsHero />
      <DescriptionFeatureSection />
      <DataSourcesFeatureSection />
      <SleuthDifferenceFeatureSection />
      <PulseFeatureSection />
    </StyledLayout>
  );
}

export function Head({ location }) {
  return (
    <SEO
      title="Sleuth Reviews"
      description="Engineering meetings made data-driven and easy with Sleuth Reviews: templates for all reviews e.g. CTO Allocations, Sprint Planning, all auto-populated with data."
      location={location}
    />
  );
}
